import Vue from "vue";
import Vuex from "vuex";

// Modules
import ecommerceStoreModule from "@/views/apps/e-commerce/eCommerceStoreModule";
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import shared from "./shared";
import dashboard from "./dashboard";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // theme modules
    app,
    appConfig,
    verticalMenu,
    "app-ecommerce": ecommerceStoreModule,
    shared,
    // main modules
    dashboard,
  },
  strict: process.env.DEV,
});
